<template>
  <div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-dropdown @command="setSelectHandOverAt">
          <el-button type="default" size="mini">
            交货期在今天后<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="handOverAtSet of handOverAtSets"
              :key="handOverAtSet.day"
              :command="handOverAtSet"
              >{{ handOverAtSet.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="mgl10" @command="setSelectHandOverAtBefore">
          <el-button type="default" size="mini">
            交货期在订单交期之前<i
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="handOverAtSet of handOverAtSetsBefore"
              :key="handOverAtSet.day"
              :command="handOverAtSet"
              >{{ handOverAtSet.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown class="mgl10" @command="setSeleteSupplier">
          <el-button type="default" size="mini">
            {{ $t("action.selectSupplier") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="supplier of suppliers"
              :key="supplier.id"
              :command="supplier"
            >
              <span
                v-if="supplier.handCycle == null || supplier.handCycle == ''"
                >{{ supplier.name }}</span
              >
              <span v-else
                >{{ supplier.name
                }}<small>(周期:{{ supplier.handCycle }})</small></span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </vxe-toolbar>

    <vxe-table
      :data="ordersNew"
      :loading="loading"
      class="recordsTable"
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="images" :title="$t('product.images')" width="85">
        <template v-slot="{ row }">
          <thumbnail :images="row.images" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="serialNo"
        :title="$t('text.serialNo')"
        min-width="85"
      >
        <template v-slot="{ row }">
          <small v-if="row.hurry" class="red">
            ({{ $t("order.hurrySimple") }})
          </small>
          {{ row.serialNo }}
          <div class="font10">{{ row.innerSerialNo }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productNo"
        :title="$t('product.productNo')"
        min-width="100"
      >
        <template v-slot="{ row }">
          {{ row.productNo }}
          <div class="font10">{{ row.color }} {{ row.size }}</div>
          <span v-if="Permit.canActions('globalSalePrice')">
            <div class="orange font10">
              <currency :code="row.currency" />
              {{ row.price }}
              <span v-if="row.currency !== 'CNY'" class="font10">
                ({{ row.cnyPrice | currency }})
              </span>
            </div>
          </span>
          <el-popover
            placement="right"
            width="560"
            trigger="click"
            @show="purchaseHistory(row)"
          >
            <el-table
              :data="purchaseHistories"
              style="width: 100%"
              border
              size="mini"
            >
              <el-table-column
                prop="total"
                :label="$t('purchase.price')"
                min-width="80px"
              >
                <template slot-scope="scope">{{
                  scope.row.price | currency
                }}</template>
              </el-table-column>
              <el-table-column
                prop="supplierName"
                :label="$t('menu.suppliers')"
                min-width="80px"
              ></el-table-column>
              <el-table-column
                prop="color"
                :label="$t('product.color')"
                min-width="80px"
              ></el-table-column>
              <el-table-column
                prop="size"
                :label="$t('product.size')"
                min-width="80px"
              ></el-table-column>
              <el-table-column
                prop="createAt"
                :label="$t('text.createAt')"
                min-width="110px"
              ></el-table-column>
              <el-table-column
                prop="settlementRemark"
                :label="$t('order.settlementRemark')"
                min-width="80px"
              >
                <template slot-scope="scope">
                  <raw-html-limit-number
                    :content="scope.row.settlementRemark"
                    :number="8"
                  />
                </template>
              </el-table-column>
            </el-table>
            <small slot="reference" class="popover-reference">{{
              $t("action.viewPurchaseHistory")
            }}</small>
          </el-popover>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="quantity"
        :title="$t('text.quantity')"
        min-width="60"
      />
      <vxe-table-column :title="$t('menu.suppliers')" min-width="150">
        <template v-slot="{ row }">
          <el-select
            size="small"
            v-model="row.defaultSupplier.supplierId"
            :placeholder="$t('rules.select', [$t('menu.suppliers')])"
            class="mgb5"
            filterable
            clearable
            @change="selectSupplier(row)"
          >
            <el-option-group
              v-for="group in groupProductSuppliers(row.productSuppliers)"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="supplier in group.suppliers"
                :key="supplier.supplierId"
                :label="supplier.supplierName"
                :value="supplier.supplierId"
              ></el-option>
            </el-option-group>
          </el-select>
          <el-input
            size="small"
            v-if="
              !(
                row.defaultSupplier.supplierPrice !== null &&
                row.defaultSupplier.supplierPrice !== 0
              )
            "
            v-model="row.defaultSupplier.price"
            :placeholder="$t('purchase.price')"
          ></el-input>
          <span
            v-if="
              row.defaultSupplier.supplierPrice !== null &&
              row.defaultSupplier.supplierPrice !== 0
            "
            >{{ row.defaultSupplier.price | currency }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column :title="$t('purchase.handOverAt')" min-width="150">
        <template v-slot="{ row }">
          <el-date-picker
            size="small"
            :placeholder="$t('text.handOverAt')"
            v-model="row.supplierHandOverAt"
            type="date"
            style="width: 100%"
          />
          <el-checkbox v-model="row._hurry" class="mgr5">
            {{ $t("order.hurry") }}
          </el-checkbox>
          <el-checkbox
            v-if="
              row.inventoryId == null &&
              row.defaultSupplier._replaceDeliver == true
            "
            v-model="row.defaultSupplier.replaceDeliver"
          >
            {{ $t("purchase.replaceDeliver") }}
          </el-checkbox>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="handOverAt"
        :title="$t('text.handOverAt')"
        width="110"
      />
      <vxe-table-column
        field="remark"
        :title="$t('text.remark')"
        min-width="80"
      >
        <template v-slot="{ row, rowIndex }">
          <div v-if="row.dealSuggest != null" class="red">
            <raw-html-limit-number :content="row.dealSuggest" :number="4" />
          </div>
          <div>
            <i
              slot="reference"
              class="el-icon-edit fl"
              @click="editRemark(row, rowIndex)"
            />
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </div>
          <div>
            <attribute :content="row.specJson" :number="6" />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" :title="$t('text.action')" width="50">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click="remove(row, rowIndex)" size="mini">
            {{ $t("text.remove") }}
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="right pd20">
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      v-if="editRemarkDF"
      width="50%"
    >
      <el-form label-width="80px">
        <tinymce-editor
          ref="editor"
          v-model="editRemarkObj.remark"
          :height="300"
        ></tinymce-editor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :title="'判断供应商饱和度结果'"
      :close-on-click-modal="false"
      :visible.sync="judgeDF"
      v-if="judgeDF"
      width="30%"
    >
      <div>
        <div v-if="judgeResults.length != 0">
          <ol class="import">
            <li v-for="(r, index) of judgeResults" :key="index" class="explain">
              <span v-if="r.type == 'fail'" class="grey">{{ r.message }}</span>
              <span v-if="r.type == 'success'" class="green">{{
                r.message
              }}</span>
            </li>
          </ol>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="judgeDoing"
          size="small"
          @click="judgeSubmit"
          >{{ $t("order.confirm") }}</el-button
        >
        <el-button size="small" @click="judgeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import Currency from "@/components/Currency";
import TinymceEditor from "@/components/TinymceEditor";
import Supplier from "@/api/supplier.js";
import Order from "@/api/order.js";
import Purchase from "@/api/purchase.js";

export default {
  props: {
    orders: Array,
  },
  mixins: [page],
  components: {
    Thumbnail,
    Currency,
    TinymceEditor,
  },
  data() {
    return {
      suppliers: [],
      handOverAtSets: [
        { day: 3, name: "3天" },
        { day: 4, name: "4天" },
        { day: 5, name: "5天" },
        { day: 7, name: "7天" },
        { day: 10, name: "10天" },
        { day: 15, name: "15天" },
        { day: 20, name: "20天" },
        { day: 25, name: "25天" },
        { day: 30, name: "30天" },
      ],
      handOverAtSetsBefore: [
        { day: 1, name: "1天" },
        { day: 2, name: "2天" },
        { day: 3, name: "3天" },
        { day: 4, name: "4天" },
        { day: 5, name: "5天" },
        { day: 6, name: "6天" },
        { day: 7, name: "7天" },
        { day: 10, name: "10天" },
        { day: 15, name: "15天" },
      ],
      purchaseHistories: [],
      //
      ordersNew: [],
      submitDoing: false,
      loading: false,
      //编辑备注
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        uuid: null,
      },
      editRemarkDoing: false,
      //
      judgeDF: false,
      judgeDoing: false,
      judgeResults: [],
      submitData: [],
    };
  },
  watch: {
    orders() {
      this.getOrdersNew();
    },
  },
  created() {
    const self = this;
    Supplier.findNoHiddenByTenantId().then(function (res) {
      if (res.status === 200) {
        self.suppliers = res.data;
      } else {
        self.sysError();
      }
      self.getOrdersNew();
    });
  },
  methods: {
    //
    editRemark(row, rowIndex) {
      this.editRemarkObj.uuid = row.uuid;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      Order.updateRemark(self.editRemarkObj).then(function (res) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.ordersNew[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    getOrdersNew() {
      const self = this;
      self.loading = true;
      Order.batchPrePurchaseing(self.orders.map((o) => o.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.ordersNew = res.data;
          for (const o of self.ordersNew) {
            Vue.set(o, "_hurry", o.hurry);
            Vue.set(
              o.defaultSupplier,
              "_replaceDeliver",
              o.defaultSupplier.replaceDeliver
            );
          }
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },
    // 采购历史
    purchaseHistory(row) {
      const self = this;
      self.purchaseHistories = [];
      const obj = {
        productNo: row.productNo,
        pageSize: 10,
      };
      Purchase.history(obj).then(function (res) {
        if (res.status === 200) {
          self.purchaseHistories = res.data;
        } else {
          self.sysError();
        }
      });
    },
    setSeleteSupplier(supplier) {
      for (const r of this.ordersNew) {
        r.defaultSupplier.supplierId = supplier.id;
        const selectedSupplier = r.productSuppliers.find(
          (ps) => ps.supplierId === r.defaultSupplier.supplierId
        );
        if (selectedSupplier != null) {
          r.defaultSupplier.supplierName = selectedSupplier.supplierName;
          r.defaultSupplier.supplierTenantId =
            selectedSupplier.supplierTenantId;
          r.defaultSupplier.price = selectedSupplier.price;
          r.defaultSupplier.replaceDeliver = selectedSupplier.replaceDeliver;
          r.defaultSupplier._replaceDeliver = selectedSupplier.replaceDeliver;
          if (selectedSupplier.replaceDeliver === false) {
            r.defaultSupplier.replaceDeliver = supplier.replaceDeliver;
            r.defaultSupplier._replaceDeliver = supplier.replaceDeliver;
          }
          r.defaultSupplier.supplierPrice = selectedSupplier.price;
          r.defaultSupplier.supplierUrl = selectedSupplier.supplierUrl;
        }
      }
    },
    setSelectHandOverAt(handOverAtSet) {
      for (const r of this.ordersNew) {
        r.supplierHandOverAt = Util.nowAddDay(handOverAtSet.day);
      }
    },
    setSelectHandOverAtBefore(handOverAtSet) {
      for (const r of this.ordersNew) {
        if (r.handOverAt !== null) {
          let diffDay = Util.dateDiff(r.handOverAt, new Date());
          if (diffDay < 0) {
            r.supplierHandOverAt = Util.nowAddDay(1);
          } else {
            r.supplierHandOverAt = Util.nowAddDay(diffDay - handOverAtSet.day);
          }
        }
      }
    },
    groupProductSuppliers(suppliers) {
      const productSuppliers = suppliers.filter(
        (p) => p.id !== -1 && p.id !== -2
      );
      const otherSuppliers = suppliers.filter((p) => p.id == -1);
      let data = [];
      if (productSuppliers.length != 0) {
        data.push({
          label: "产品供应商",
          suppliers: Util.objArraySort2(productSuppliers, "sequence"),
        });
      }
      if (otherSuppliers.length != 0) {
        data.push({
          label: "其他供应商",
          suppliers: Util.objArraySort2(otherSuppliers, "sequence"),
        });
      }
      if (data.length !== 0 && data.length == 1) {
        data[0].label = "";
      }
      return data;
    },
    selectSupplier(row) {
      const selectedSupplier = row.productSuppliers.find(
        (ps) => ps.supplierId === row.defaultSupplier.supplierId
      );
      row.defaultSupplier.supplierName = selectedSupplier.supplierName;
      row.defaultSupplier.supplierTenantId = selectedSupplier.supplierTenantId;
      row.defaultSupplier.price = selectedSupplier.price;
      row.defaultSupplier.replaceDeliver = selectedSupplier.replaceDeliver;
      row.defaultSupplier._replaceDeliver = selectedSupplier.replaceDeliver;
      row.defaultSupplier.supplierPrice = selectedSupplier.price;
      row.defaultSupplier.supplierUrl = selectedSupplier.supplierUrl;
    },
    submit() {
      const self = this;
      if (self.ordersNew.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.submitData = [];
      let dataJudge = [];
      for (const o of self.ordersNew) {
        if (
          o.defaultSupplier.supplierId == null ||
          o.supplierHandOverAt == null
        ) {
          self.$message({
            message: self.$t("prompt.purchaseMustFillSupplierHandOverAt"),
            type: "warning",
          });
          return;
        }
        const obj = {
          id: o.id,
          handOverAt: Util.formatDate(o.supplierHandOverAt),
          hurry: o._hurry,
          supplierId: o.defaultSupplier.supplierId,
          supplierName: o.defaultSupplier.supplierName,
          supplierTenantId: o.defaultSupplier.supplierTenantId,
          price: o.defaultSupplier.price || 0,
          remark: o.remark,
          replaceDeliver: null,
        };
        if (obj.price === "") {
          obj.price = 0;
        }
        if (
          o.inventoryId != null ||
          o.defaultSupplier.supplierTenantId == null
        ) {
          obj.replaceDeliver = false;
        } else {
          obj.replaceDeliver = o.defaultSupplier.replaceDeliver || false;
        }
        self.submitData.push(obj);
        dataJudge.push({
          supplierId: o.defaultSupplier.supplierId,
          quantity: o.quantity,
        });
      }
      self.judgeResults = [];
      Supplier.calcCapacity(dataJudge).then(function (res) {
        if (res.data.allQuantity == res.data.successQuantity) {
          self.batchPurchaseFun();
        } else {
          self.judgeResults = res.data.results;
          self.judgeDoing = false;
          self.judgeDF = true;
        }
      });
    },

    judgeSubmit() {
      const self = this;
      self.judgeDoing = true;
      Order.batchPurchase(self.submitData).then(function (res) {
        self.judgeDoing = false;
        self.judgeDF = false;
        if (res.status === 200) {
          self.sysResults(res.data, self.$t("prompt.dealSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchPurchase");
        } else {
          self.sysError();
        }
      });
    },

    batchPurchaseFun() {
      const self = this;
      self.submitDoing = true;
      Order.batchPurchase(self.submitData).then(function (res) {
        self.submitDoing = false;
        if (res.status === 200) {
          self.sysResults(res.data, self.$t("prompt.dealSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchPurchase");
        } else {
          self.sysError();
        }
      });
    },

    close() {
      this.$emit("close");
    },
    remove(row, rowIndex) {
      this.ordersNew.splice(rowIndex, 1);
    },
  },
};
</script>
